<template>
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Sub Especialidades</span>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-sm-9">
        <label>Especialidades</label>
        <select class="form-select" v-model="selecionar">
          <option v-for="item in especialidades" :key="item.id" :value="item">
            {{ item.especialidade.nome }}
          </option>
        </select>
      </div>
      <div class="col justify-content-end" style="margin-top: 20px">
        <div class="col">
          <div class="float-end">
            <div class="row">
              <div class="col">
                <button type="button" class="btn btn-primary" @click="selecionarItem" style="margin-right: 10px">Selecionar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row" v-if="nomeSelecionado !== null">
        <h4>Especialidade - {{ nomeSelecionado }}</h4>
      </div>
      <div class="container" v-if="idSelecionado !== null">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <button @click="goToCreate()" class="btn btn-primary" style="margin: 10px 10px">Editar SubEspecialidades</button>
          </div>
        </div>
      </div>
      <a-table :dataSource="todasSubEspecialidades" :columns="columns">
        <template #nome="{ record }">
          <span>{{ stringNomeEspec(record) }}</span>
        </template>
      </a-table>
      <div class="row">
        <div class="col d-flex justify-content-center">
          <button @click="voltar" class="btn btn-success" style="margin-right: 10px">Voltar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEspecialidades } from '@/components/service/especilidadeService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'PageSubEspecialidade',
  data() {
    return {
      todasSubEspecialidades: [],
      especialidades: [],
      selecionar: null,
      nomeSelecionado: null,
      idSelecionado: null,
      existeSubEspecialidadeCadastradaLegado: false,
      columns: [
        {
          title: 'Sub Especialidade',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },
      ],
    };
  },
  async created() {
    await this.getEspecialidades();
  },
  methods: {
    async getEspecialidades() {
      await getEspecialidades().then((esp) => {
        this.especialidades = esp.data;
      });
    },
    selecionarItem() {
      if (this.selecionar !== null) {
        this.todasSubEspecialidades = [];
        if (this.selecionar.subEspecialidade) {
          this.existeSubEspecialidadeCadastradaLegado = true;
          this.todasSubEspecialidades = this.selecionar.subEspecialidade;
        } else {
          this.existeSubEspecialidadeCadastradaLegado = false;
        }
        this.nomeSelecionado = this.selecionar.especialidade.nome;
        this.idSelecionado = this.selecionar.id;
        this.selecionar = null;
      }
    },
    stringNomeEspec(obj) {
      return obj.nome;
    },
    voltar() {
      this.$router.push('/home');
    },
    goToCreate() {
      if (this.idSelecionado != null) {
        if (this.existeSubEspecialidadeCadastradaLegado) {
          this.$router.push({ path: '/form-sub-especialidade/editar', query: { id: this.idSelecionado } });
        } else {
          openNotification(typesNotification.success, 'Não existe SubEpecialidade cadastrada no SICAD');
        }
      }
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}
</style>
